/* global axios */
/* eslint class-methods-use-this: 0 */
import ApiClient from './ApiClient';
import CallApi from '../helper/callHelper';

class CallCenterAPI extends ApiClient {
  constructor() {
    super('callcenters', { accountScoped: true });
  }

  records(search) {
    return axios.post(`${this.url}/search`, {
      search: search,
    });
  }

  dial = (basePath, data) => {
    return CallApi.post(basePath + '/v2/dial', data);
  };

  hangup = (basPath, data) => {
    return CallApi.post(basPath + '/v2/hangup', data);
  };

  setDnd = (basePath, data) => {
    return CallApi.post(basePath + '/v2/setdnd', data);
  };

  keepCall = (basePath, data) => {
    return CallApi.post(basePath + '/v2/hold', data);
  };

  transfer = (basePath, data) => {
    return CallApi.post(basePath + '/v2/transfer', data);
  };

  conference = (basePath, data) => {
    return CallApi.post(basePath + '/v2/conference', data);
  };

  phoneLocation = (basePath, data) => {
    return CallApi.post(basePath + '/v2/phoneLocation', data);
  };

  getdnd = (basePath, data) => {
    return CallApi.post(basePath + '/v2/getdnd', data);
  };

  getCdrRecords = (basePath, data) => {
    return CallApi.post(basePath + '/v2/getCdrRecords', data);
  };

  getExtensionStatus = (basePath, data) => {
    return CallApi.post(basePath + '/v2/getextensionstatus', data);
  };

  canhelp = (basePath, data) => {
    return CallApi.post(basePath + '/v2/canhelp', data);
  };

  getDestination = (basePath, data) => {
    return CallApi.post(basePath + '/v2/getDestination', data);
  };
}

export default new CallCenterAPI();
